'use client';

import { CacheKey } from '@eliadmin/core/src/api/constants';
import { fetchSlugDetail } from '@eliadmin/core/src/api/slugs/slugs-api';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { useSuspenseQuery } from '@tanstack/react-query';
import { CourseDetailPage } from './course-detail-page';

type CourseRouterProps = {
  slug: string;
};
export function CourseRouter(props: CourseRouterProps) {
  const locale = useLocaleStore(s => s.currentLocale);
  const authToken = useCustomerStore(s => s.me?.authToken);

  const courseQuery = useSuspenseQuery({
    queryKey: [CacheKey.COURSE_DETAIL, locale, props.slug, authToken ?? null],
    // Public content is already hydrated by the server. Auth keeps a separate
    // key and immediate revalidation for private flags/prices.
    staleTime: authToken ? 0 : 60_000,
    queryFn: () =>
      fetchSlugDetail({ locale, slug: props.slug, authToken }).then(
        res => res['App\\Models\\Course\\Course'] ?? null,
      ),
  });

  if (!courseQuery.data) {
    return null;
  }

  return <CourseDetailPage course={courseQuery.data} />;
}
